<template>
  <div style="width:100%;  ">
    <div class="container">
      <svg class="base" viewBox="0 0 897 57" xmlns="http://www.w3.org/2000/svg"></svg>
      <svg class="base-offset" viewBox="0 0 897 57" xmlns="http://www.w3.org/2000/svg"></svg>
      <svg class="overlay" viewBox="0 0 40 59" xmlns="http://www.w3.org/2000/svg"></svg>
      <svg class="small-svg" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M 4.5,-0.5 C 5.83333,-0.5 7.16667,-0.5 8.5,-0.5C 10.5,0.833333 12.5,0.833333 14.5,-0.5C 15.8333,-0.5 17.1667,-0.5 18.5,-0.5C 19.9303,0.53747 21.597,1.20414 23.5,1.5C 23.5,8.83333 23.5,16.1667 23.5,23.5C 22.8333,23.5 22.5,23.8333 22.5,24.5C 15.1667,24.5 7.83333,24.5 0.5,24.5C 0.5,23.8333 0.166667,23.5 -0.5,23.5C -0.5,16.1667 -0.5,8.83333 -0.5,1.5C 1.55292,1.59794 3.21959,0.931268 4.5,-0.5 Z M 2.5,8.5 C 8.5,8.5 14.5,8.5 20.5,8.5C 20.6655,12.5138 20.4988,16.5138 20,20.5C 14.3333,21.8333 8.66667,21.8333 3,20.5C 2.50115,16.5138 2.33449,12.5138 2.5,8.5 Z"/>
      </svg>
      <svg class="text-svg" viewBox="0 0 897 57" xmlns="http://www.w3.org/2000/svg">
        <text x="897" y="29" font-size="16" stroke="black" text-anchor="end" stroke-width="0.5">
          2023年00月00日～2023年00月00日
        </text>
      </svg>

    </div>


    <div style="position:relative;margin:40px;">
      <div style="position: absolute;top:0px;bottom:0px; right:0px;left:0px;">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" viewBox="0 0 897 57"
             style="shape-rendering:geometricPrecision;
            text-rendering:geometricPrecision;
            image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <path :style="`fill:${accentColor}`"
                  d="M -0.5,-0.5 C 298.5,-0.5 597.5,-0.5 896.5,-0.5C 896.5,18.5 896.5,37.5 896.5,56.5C 597.5,56.5 298.5,56.5 -0.5,56.5C -0.5,37.5 -0.5,18.5 -0.5,-0.5 Z"/>
          </g>
        </svg>
      </div>
      <div style="position: absolute;top:5px;bottom:0px; right:0px;left:5px;">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" viewBox="0 0 897 57"
             style="shape-rendering:geometricPrecision;
            text-rendering:geometricPrecision;
            image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <path :style="`fill:${borderColor}`"
                  d="M -0.5,-0.5 C 298.167,-0.5 596.833,-0.5 895.5,-0.5C 895.5,18.1667 895.5,36.8333 895.5,55.5C 596.833,55.5 298.167,55.5 -0.5,55.5C -0.5,36.8333 -0.5,18.1667 -0.5,-0.5 Z M 1.5,1.5 C 298.833,1.5 596.167,1.5 893.5,1.5C 893.5,18.8333 893.5,36.1667 893.5,53.5C 596.167,53.5 298.833,53.5 1.5,53.5C 1.5,36.1667 1.5,18.8333 1.5,1.5 Z"/>
          </g>
        </svg>
      </div>
      <div style="position: absolute;left:7px; top:-8px;bottom: 0px;right:0px;">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="4%" viewBox="0 0 40 59"
             style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <path fill="#ad512f"
                  d="M 3.5,-0.5 C 4.5,-0.5 5.5,-0.5 6.5,-0.5C 15.1401,9.13053 22.1401,19.7972 27.5,31.5C 25.7334,33.8901 23.4001,35.5568 20.5,36.5C 17.8852,34.6212 15.7186,32.2879 14,29.5C 8.89451,22.2728 4.06118,14.9395 -0.5,7.5C -0.5,6.16667 -0.5,4.83333 -0.5,3.5C 0.5,1.83333 1.83333,0.5 3.5,-0.5 Z"/>
          </g>
          <g>
            <path fill="#6f3c25"
                  d="M 27.5,31.5 C 29.83,35.4921 32.1633,39.4921 34.5,43.5C 32.3549,44.9885 30.0215,45.9885 27.5,46.5C 25.1695,43.175 22.8361,39.8417 20.5,36.5C 23.4001,35.5568 25.7334,33.8901 27.5,31.5 Z"/>
          </g>
          <g>
            <path fill="#c9a76e"
                  d="M 34.5,43.5 C 37.6448,46.6848 38.9781,50.6848 38.5,55.5C 37.8333,55.1667 37.1667,54.8333 36.5,54.5C 36.5,55.1667 36.5,55.8333 36.5,56.5C 31.3115,55.0853 28.3115,51.7519 27.5,46.5C 30.0215,45.9885 32.3549,44.9885 34.5,43.5 Z"/>
          </g>
          <g>
            <path fill="#8e613e"
                  d="M 36.5,54.5 C 35.1634,53.6851 34.1634,52.5185 33.5,51C 35.4784,51.033 36.4784,52.1996 36.5,54.5 Z"/>
          </g>
          <g>
            <path fill="#9c7148"
                  d="M 36.5,54.5 C 37.1667,54.8333 37.8333,55.1667 38.5,55.5C 38.5,55.8333 38.5,56.1667 38.5,56.5C 37.8333,56.5 37.5,56.8333 37.5,57.5C 36.8333,57.5 36.5,57.1667 36.5,56.5C 36.5,55.8333 36.5,55.1667 36.5,54.5 Z"/>
          </g>
          <g>
            <path fill="#713e26"
                  d="M 38.5,56.5 C 38.8333,56.5 39.1667,56.5 39.5,56.5C 39.5,57.1667 39.5,57.8333 39.5,58.5C 38.8333,58.5 38.1667,58.5 37.5,58.5C 37.5,58.1667 37.5,57.8333 37.5,57.5C 37.5,56.8333 37.8333,56.5 38.5,56.5 Z"/>
          </g>
        </svg>

      </div>

      <div style="position: absolute;top:5px;bottom:0px; right:0px;left:5px;">
        <svg width="100%" viewBox="0 0 897 57" xmlns="http://www.w3.org/2000/svg" class="kaisei">
          <text x="60" y="35" font-size="20" stroke="black" text-anchor="start" stroke-width="0.5"> 執　筆　記　録</text>

        </svg>
      </div>
      <div style="position: absolute;top:5px;bottom:0px; right:0px;left:5px;">
        <div style="display: flex">
          <svg xmlns="http://www.w3.org/2000/svg"
               style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd">
            <g viewBox="0 0 24 25"
               width="4%">
              <path :fill="borderColor"
                    d="M 4.5,-0.5 C 5.83333,-0.5 7.16667,-0.5 8.5,-0.5C 10.5,0.833333 12.5,0.833333 14.5,-0.5C 15.8333,-0.5 17.1667,-0.5 18.5,-0.5C 19.9303,0.53747 21.597,1.20414 23.5,1.5C 23.5,8.83333 23.5,16.1667 23.5,23.5C 22.8333,23.5 22.5,23.8333 22.5,24.5C 15.1667,24.5 7.83333,24.5 0.5,24.5C 0.5,23.8333 0.166667,23.5 -0.5,23.5C -0.5,16.1667 -0.5,8.83333 -0.5,1.5C 1.55292,1.59794 3.21959,0.931268 4.5,-0.5 Z M 2.5,8.5 C 8.5,8.5 14.5,8.5 20.5,8.5C 20.6655,12.5138 20.4988,16.5138 20,20.5C 14.3333,21.8333 8.66667,21.8333 3,20.5C 2.50115,16.5138 2.33449,12.5138 2.5,8.5 Z"/>
            </g>
          </svg>
          <svg width="100%" viewBox="0 0 897 57" xmlns="http://www.w3.org/2000/svg">
            <text x="877" font-size="16" :stroke="borderColor" text-anchor="end" stroke-width="0.5">
              2023年00月00日～2023年00月00日
            </text>
          </svg>

        </div>
      </div>


    </div>
  </div>

</template>

<script>
export default {
  name: "NovelDiaryCalendarTopFukidashi",
  data() {
    return {
      accentColor: null,
      borderColor: null
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.diaryAccent
    this.borderColor = this.$vuetify.theme.themes.light.diaryPrimary
  },
}
</script>

<style>
.container {
  position: relative;
  width: 100%;
}

.base,
.base-offset,
.overlay {
  position: absolute;
}

.base,
.base-offset {
  width: 100%;
  height: auto;
}

.base-offset {
  top: 5px;
  left: 5px;
}

.overlay {
  width: 40px;
  height: 59px;
  top: 0;
  left: 0;
}

.small-svg {
  position: absolute;
  width: 24px;
  height: 25px;
  top: 16px;
  right: calc(100% - 898px);
}

.text-svg {
  position: absolute;
  top: 0;
  right: 24px;
  width: calc(100% - 24px);
  height: 57px;
}
</style>